require("./sass/styles.scss");

import $ from "jquery";
import slick from "slick-carousel";
import L from "leaflet";
import CC from "cookieconsent";

import "@fancyapps/fancybox/dist/jquery.fancybox.js";
import "./jquery.nav.js";

$(window).on("load", function () {
    $('.contentmenu').onePageNav({
        currentClass: 'menu--active',
        changeHash: true,
        scrollSpeed: 750
    });
    $.get('/fonts-ping');
});

$(function () {
    $(".menubutton").click(function (e) {
        e.preventDefault();
        $("body").toggleClass("overlay--show");
        if ($(this).hasClass("menubutton--close")) {
            history.replaceState({}, "page 2", this.href);
        }
        if ($("body").hasClass("overlay--show") && this.href != "javascript:;") {
            $(".overlay_loader").load(this.href + "?ajax=1");
            $(".menubutton--close").attr("href", location.href);
            history.replaceState({}, "page 2", this.href);
        }
    })
    $(".overlay").on("click", ".mainmenu--content a", function (e) {
        e.preventDefault();
        $(".overlay_loader").load(this.href + "?ajax=1");
        history.replaceState({}, "page 2", this.href);
    });
    $(".popup").fancybox({
        fullScreen: false,
        thumbs: false,
        slideShow: false
    });
    $(".slider").slick({
        dots: true,
        fade: false,
        appendArrows: $(document.getElementById('slidernumber')),
    });
    $(window).trigger('scroll.onePageNav');

    $(".mapcontainer").each(function () {
        var map = L.map('map', {
            closePopupOnClick: false,
            scrollWheelZoom: false
        }).setView([51.9667, 7.6333], 13);
        // var osmUrl='http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        // var osmUrl='https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png';
        var osmUrl = 'https://www.lwl.org/osmlwlde/tiles/{z}/{x}/{y}.png';
        var osmAttrib = 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
        var osm = new L.TileLayer(osmUrl, {attribution: osmAttrib});
        map.addLayer(osm);

        var template = '<h3>$Name</h3>'
            + '<a href="$Url"><img src="$Image"/></a>'
            + '<p><a href="$Url">Seite öffnen</a></p>';

        $(".mapitem").each(function () {
            var lat = $(this).data("lat");
            var lng = $(this).data("lng");
            var classes = $(this).data("classes");
            var content = $(this).html();

            var icon = L.divIcon({
                className: 'map-marker ',
                iconSize: null,
                html: '<div class="mapicon ' + classes + '"></div>'
            });

            var latlng = [lat, lng];

            var marker = L.marker(latlng, {icon: icon}).on('click', function () {
                //var popup = this.getPopup();
                //this.openPopup()
                //alert("ding");
            });
            marker.bindPopup(content, {'maxWidth': 219});

            marker.addTo(map);
        });
    })

    var pkBaseURL = "https://piwik.lwl.org/piwik/";

    // var d = document, g = d.createElement("script"), s = d.getElementsByTagName("script")[0];
    // g.type = "text/javascript";
    // g.defer = true;
    // g.async = true;
    // g.src = "https://piwik.lwl.org/piwik/piwik.js";
    // s.parentNode.insertBefore(g, s);


    // Actually starting analytics up
    function addAnalytics() {

        var initPiwik = function (tag) {
            var tracker = Piwik.getTracker(pkBaseURL + 'piwik.php', tag);

            tracker.setCookieConsentGiven();
            tracker.trackPageView();
            tracker.enableLinkTracking();
            window.tracker = tracker;
            console.log('Initialized: ', tag);
        }

        try {
            initPiwik(2);
        } catch (err) {
        }
        try {
            initPiwik(276);
        } catch (err) {
        }
    }

    function optOut() {
        if (window.tracker) {
            tracker.disableCookies();
            tracker.optUserOut();
        }
    }

    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "#1A1919",
                "text": "#ffffff"
            },
            "button": {
                "background": "transparent",
                "text": "#ffffff",
                "border": "#ffffff"
            }
        },
        "position": "bottom",
        "type": "opt-in",
        "content": {
            "header": "Dürfen wir Cookies verwenden?",
            "message": "Dürfen wir Cookies verwenden? Ein Cookie ist eine Textinformation, die im Browser auf dem Endgerät des Betrachters jeweils zu einer besuchten Website gespeichert werden kann. Sie helfen uns und Dritten dabei, den Internetauftritt komfortabel bereitzustellen und zu analysieren, wie unsere Seiten benutzt werden. Sie können Ihre Einwilligung jederzeit über die Cookie-Einstellungen unten auf der Seite widerrufen.",
            "allow": "Einverstanden",
            "deny": "Ablehnen",
            "link": "Unsere Datenschutzerklärung",
            "href": "https://www2.lwl.org/de/LWL/portal/datenschutzerklaerung/",
            "policy": 'Cookie Einstellungen'
        },
        onInitialise: function (status) {
            var didConsent = this.hasConsented();
            if (didConsent) {
                addAnalytics();
            } else {
                optOut();
            }
        },
        onStatusChange: function (status, chosenBefore) {
            var didConsent = this.hasConsented();
            if (didConsent) {
                addAnalytics();
            } else {
                optOut();
            }
        },
        onRevokeChoice: function () {
            optOut();
        },
    });
});



// WEBPACK FOOTER //
// ./skulpturprojekte/src/main.js